import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Link } from 'react-router-dom'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Header from '../../components/Header'
import MissingTranslations from '../../components/MissingTranslations'
import Page from '../../components/Page'
import Paginator from '../../components/Paginator'
import Sorter, { SortControl } from '../../components/Sorter'
import StickyTable from '../../components/StickyTable'
import { MAIN_LANG } from '../../consts'
import { useQsFilters } from '../../hooks/filters'
import { Territorio } from '../../types'
import { useDeleteTerritorio, useTerritories } from '../../hooks/territories'

const initFilters = (params: URLSearchParams) => ({
  page: Number(params.get('page') ?? 1),
  search: params.get('search') ?? '',
  ordering: params.get('ordering') ?? '',
})

const MISSING_TRANSLATIONS_FIELDS = ['title']

export default function ContentsList() {
  const { filters, uiFilters, setFiltersDebounced, setFilters } =
    useQsFilters(initFilters)
  const { data } = useTerritories(filters)
  const deleteTerritorio = useDeleteTerritorio()
  const [modalRm, modalRmActions] = useModalTrigger<Territorio>()

  return (
    <Page padded>
      <Header>
        <div className="d-flex align-items-end">
          <h2 className="m-0">Territori</h2>
          <div className="counter ms-2 mb-1">
            <small>
              {data!.count}
              {' / '}
              {data!.total_count}
            </small>
          </div>
        </div>
        <Link className="btn btn-primary" to="/territories/new">
          <i className="bi bi-plus-circle me-2"></i> Aggiungi
        </Link>
      </Header>
      <div className="d-flex justify-content-between mt-3 mb-3 align-items-center">
        <input
          placeholder="Cerca"
          className="form-control w-auto"
          type="text"
          value={uiFilters.search}
          onChange={(e) =>
            setFiltersDebounced({ search: e.target.value, page: 1 })
          }
        />
      </div>
      <StickyTable className="flex-1">
        <thead>
          <Sorter
            value={uiFilters.ordering}
            onSortChange={(ordering) =>
              setFilters({
                ordering,
                page: 1,
              })
            }
          >
            <tr>
              <th>#</th>
              <th>
                <div className="d-flex align-items-center">
                  Titolo
                  <SortControl field={`title__${MAIN_LANG}`} />
                </div>
              </th>
              <th>
                <div className="d-flex align-items-center">
                  Ordine
                  <SortControl field={`order`} />
                </div>
              </th>
              {/* <th>
                Tema
              </th> */}
              <th></th>
            </tr>
          </Sorter>
        </thead>
        <tbody>
          {data!.results.map((territorio) => (
            <tr key={territorio.id}>
              <td>{territorio.id}</td>
              <td>
                <Link to={`/territories/${territorio.id}`}>{territorio.title[MAIN_LANG]}</Link>
                <MissingTranslations
                  data={territorio}
                  fields={MISSING_TRANSLATIONS_FIELDS}
                />
              </td>
              <td>{territorio.order}</td>
              {/* <td>
                {serie.themes.length > 0 ? 'Si' : 'No'}
              </td> */}
              <td>
                <i
                  onClick={() => modalRmActions.open(territorio)}
                  className="bi cursor-pointer text-danger bi-trash3-fill"
                ></i>
              </td>
            </tr>
          ))}
        </tbody>
      </StickyTable>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare il territorio 
              {modalRm.value.title[MAIN_LANG]} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btn-outline-primary"
          >
            Annulla
          </button>
          <button
            className="btn  btn-danger"
            disabled={deleteTerritorio.isLoading}
            onClick={async () => {
              await deleteTerritorio.mutateAsync(modalRm.value!.id)
              modalRmActions.close()
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
      <div className="position-relative">
        <Paginator
          count={data!.count}
          currentPage={uiFilters.page}
          goToPage={(page) => setFilters({ page })}
        />
      </div>
    </Page>
  )
}
